import React from "react";
import { makeStyles } from "tss-react/mui";
import { Card, CardHeader, CardFooter, CardContent } from "../../components/card";
import { useQuiz } from './hooks';
import { ScreenTypes } from "../../store/quiz/quizSlice";
import { Typography, Box, Grid, Button } from '@mui/material';
import startAssessmentSvg from '../../assets/svgs/assessmentsIcons/startAssessment.svg';
import arrowSvg from '../../assets/svgs/arrow.svg';
import assessmentBgSvg from '../../assets/svgs/assessmentsIcons/assessmentBg.svg';

const useStyles = makeStyles()((theme) => ({
    questionText: {
        width: '100%',
        clear: 'both',
        float: 'left',
        textAlign: 'center',
        fontWeight: 'bold',
        margin: '40px 0',
        fontSize: '14px'
    },
    cardHeader: {
        fontSize: '40px', fontWeight: '700!important', marginBottom: '30px',
        color: 'rgba(68, 122, 226, 1)',
        textAlign: 'center',
        marginBottom: theme.spacing(4) + '!important'
    },
    cardContent: { padding: '10px 20px' },
    imageContainer: {

    },
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        bottom: '0px',
        left: '50%',
        transform: 'translate(-50%, 50%)'
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        transition: 'transform 0.1s ease, box-shadow 0.1s ease',
        width: '468px',
        '&:disabled': {
            opacity: 0.5,
            cursor: 'not-allowed',
        },
        '&:not(:disabled):active': {
            transform: 'scale(0.95)',
        },
    },
    buttonImage: {
        width: '100%'
    },
    footer: {
        marginTop: theme.spacing(4),
        border: 'none!important',
        textAlign: 'center'
    }
}));

export default function QuizDetail({ style = {}, setAssessmentBegin }) {
    const { setScreen, quizDetails, quizTopic } = useQuiz();
    const { classes } = useStyles();

    // const { selectedQuizTopic, noOfQuestions, totalMarks, totalTime } = quizDetails;

    const goToQuestionScreen = () => {
        setScreen(ScreenTypes.QuestionScreen)
        setAssessmentBegin(true)
    }

    return (
        <Box sx={{ position: 'relative' }}>
            <Typography sx={{
                color: '#447AE2',
                fontSize: { xs: '1em', sm: '1em', md: '1.4em', lg: '1.6em', xl: '2em' },
                fontFamily: '"Quicksand", sans-serif',
                fontWeight: '700',
                textAlign: 'center',
            }} >
                Speech Evaluation Complete
            </Typography>
            <Typography sx={{
                color: '#464255',
                fontSize: '0.8em',
                fontFamily: '"Quicksand", sans-serif',
                fontWeight: '700',
                textAlign: 'center',
                m: 1
            }} >
                Click on ‘Start Assessment’ to begin the assessment.
            </Typography>

            <Box sx={{
                // display: 'flex',
                // justifyContent: 'center',
                // alignItems: 'center,
                // p: 1,
                // background: '#E6F4FD',
                // border: '1px solid #BED5E4',
                // borderRadius: 1,
                m: 1,
                textAlign: 'center',
                position: 'relative',
            }}>

                <img style={{ width: '75%' }} src={assessmentBgSvg} alt="" />
                <Typography sx={{
                    color: '#000000',
                    fontSize: { xs: '0.5em', sm: '1.2em', md: '0.6em', lg: '0.9em', xl: '1.2em' },
                    fontFamily: '"Quicksand", sans-serif',
                    fontWeight: '600',
                    textAlign: 'center',
                    position: 'absolute',
                    top: '6%',
                    left: '19%'

                }} >
                    <span style={{ fontWeight: 700, color: '#6945A9' }}>{quizDetails?.noOfQuestions}</span> <br />
                    No. Questions
                </Typography>
                <Typography sx={{
                    color: '#000000',
                    fontSize: { xs: '0.5em', sm: '1.2em', md: '0.6em', lg: '0.9em', xl: '1.2em' },
                    fontFamily: '"Quicksand", sans-serif',
                    fontWeight: '600',
                    textAlign: 'center',
                    position: 'absolute',
                    top: '28%',
                    right: '27%'
                }} >
                    <span style={{ fontWeight: 700, color: '#6945A9' }}>{quizDetails?.timeAllowed}</span><br />
                    Minutes
                </Typography>
                <Typography sx={{
                    color: '#000000',
                    fontSize: { xs: '0.5em', sm: '1.2em', md: '0.6em', lg: '0.8em', xl: '1em' },
                    fontFamily: '"Quicksand", sans-serif',
                    fontWeight: '600',
                    textAlign: 'center',
                    position: 'absolute',
                    bottom: '13%',
                    left: '14%'
                }} >
                    <span style={{
                        fontWeight: 700, background: 'linear-gradient(180deg, #49C8F7 0%, #0C6184 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}>{quizDetails?.totalMarks}</span><br />
                    Score in Total
                </Typography>
            </Box>
            <Box sx={{ position: 'relative' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    {/* <img src={startAssessmentSvg} width={'50%'} /> */}
                </Box>
                <Box
                    sx={{
                        background: 'linear-gradient(0deg, #CCCCCC -2.68%, #E6E6E6 31.68%, #F8F8F8 64.23%, #FFFFFF 87.74%)',
                        left: '50%',
                        borderRadius: '50px',
                        padding: '5px 5px',
                        transform: 'translateX(-50%)',
                        position: 'absolute',
                        bottom: '-30px',
                        width: { xs: '60%', sm: 'auto' },
                    }}
                >
                    <Button
                        sx={{
                            background: 'linear-gradient(to top, #01afff, #23b5ff, #36bbff, #46c1ff, #54c7ff, #5ecafe, #67cefe, #70d1fd, #78d2fc, #7fd4fa, #85d5f9, #8cd6f8)',
                            color: '#fff',
                            borderRadius: '50px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: { xs: '5px 10px', sm: '10px 20px' },
                            width: '100%',
                            position: 'relative',
                            overflow: 'hidden',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                width: '100%',
                                height: '50%',
                                background: 'rgba(255, 255, 255, 0.3)',
                                borderRadius: 'inherit',
                                transform: 'translateY(-60%)',
                                filter: 'blur(10px)',
                                pointerEvents: 'none',
                            },
                            '&:hover': {
                                background: 'linear-gradient(to top, #0156ff, #006bff, #007dff, #008eff, #009dff, #00a4ff, #00abff, #0fb2ff, #18b5ff, #1fb7ff, #26baff, #2cbcff)',
                                boxShadow: '0 6px 10px rgba(0, 0, 0, 0.3)',
                            },
                        }}
                        onClick={goToQuestionScreen}
                    >
                        <Typography
                            sx={{
                                fontWeight: '600',
                                fontFamily: '"Quicksand", sans-serif',
                                fontSize: { xs: '0.8em', sm: '0.8em', md: '0.9em', lg: '1.3em', xl: '1.6em' },
                                // fontSize: { xs: '1em', sm: '1em', md: '1.4em', lg: '1.6em', xl: '2em' },
                                zIndex: 2,
                            }}
                        >
                            Start Assessment
                        </Typography>
                        <img
                            style={{
                                width: '15%',
                                maxWidth: '100%',
                                marginTop: '5px',
                                height: 'auto',
                                zIndex: 2,
                            }}
                            src={arrowSvg}
                            alt=""
                        />
                    </Button>
                </Box>
            </Box>
            <Typography sx={{
                fontWeight: '600',
                fontFamily: '"Quicksand", sans-serif',
                fontSize: { xs: '0.5em', sm: '0.5em', md: '0.5em', lg: '0.5em', xl: '0.8em' },
                textAlign: 'center',
                marginTop: 5,
                // position: 'absolute',

            }} >
                {/* To save time, you can skip questions. Skipped questions will show up at the end of the assessment. */}
                Navigate through questions using Next and Prev buttons. You must answer each question to proceed to the next one.
            </Typography>
        </Box>

    )
}